import * as types from '../constants/ActionTypes';

export function setDrawerContainerScrollParams(bookKey, scrollTop) {
   return {
      type: types.SET_DRAWER_CONTAINER_SCROLL_PARAMS,
      payload: {
         drawerContainerScrollParams: {bookKey: bookKey, scrollTop: scrollTop}
      }
   }
}



// WEBPACK FOOTER //
// ./src/actions/ctrl.js